'use strict';
//***********************************************************************************
//***********************************************************************************
import { cn_pipe_type } from '../model/cn_pipe_type';
import { cn_pipe } from '../model/cn_pipe';
import { cn_svg_tool_creation } from './cn_svg_tool_creation';
import { cn_svg_map } from './cn_svg_map';
import { cn_pipe_handler } from './cn_pipe_handler';
import { cn_polygon_handler } from './cn_polygon_handler';
import { cn_clone, cn_middle, cn_mul, cn_normal, cn_normalize, cn_sub, cnx_clone } from '../utils/cn_utilities';
import { cn_mouse_event } from './cn_mouse_event';
import { cn_element } from '../model/cn_element';
import { cn_edition_handler } from './cn_edition_handler';
import { HELPER } from '../utils/cn_wordings';
import { cn_mmm_element } from '../model/cn_mmm_element';
import { cn_mmm_composition } from '../model/cn_mmm_composition';
import { cn_mmm_handler } from './cn_mmm_handler';
import { cn_event_handler } from './cn_event_handler';
import { cn_camera } from './cn_camera';
import { cn_wall } from '../model/cn_wall';
import { cn_type_pastille } from './cn_type_pastille';

/**
 * @class cn_svg_tool_pipe_creation
 * A tool to create pipe and columns
 */
export class cn_svg_tool_mmm_creation extends cn_svg_tool_creation {
    //*****************************************************************
    /**
     * Constructor
     * @param {cn_svg_map} map
     */
    constructor(map) {
        super(map);

        this._creation_mode = 1;
        this._edition_handler = null;
        this._mmm_composition = null;
        this._creation_handler = null;
        this._initiate_creation();
        this.element_filter = element => {
            return element.constructor == cn_mmm_element || (element.constructor == cn_wall && element.has_facings());
        };
    }

    //*****************************************************************
    //*** Parameters
    //*****************************************************************
    get_creation_mode() {
        return this._creation_mode;
    }

    get_creation_modes() {
        return ["Point","Ligne","Forme"];
    }

    set_creation_mode(n) {
        this._creation_mode = n;
        this._initiate_creation();
    }

    /**
     * @returns {cn_mmm_composition} returns current pipe type
     */
    get_current_mmm_composition() {
        return this._mmm_composition;
    }

    /**
     * Sets thecurrent pipe type
     * @param {cn_mmm_composition} composition
     */
    set_current_mmm_composition(composition) {
        this._mmm_composition = composition;
        this._initiate_creation();
        this._map.refresh_main();
    }

    /**
     * Returns all pipe types inside the building
     * @returns {Array<cn_mmm_composition>}
     */
    get_element_types() {
        return this._scene.building.get_mmm_compositions();
    }

    /**
     * Selects all elements with given pipe type
     * @param {cn_mmm_composition} composition
     */
    select_elements_by_type(composition) {
        this._initiate_edition(this._scene.mmm_elements.filter(p => p.composition == composition));
    }

    //*****************************************************************
    //*** Must return 'true' if wa are in modal creation.
    //*****************************************************************
    is_creating() {
        return this._creation_handler.is_creating();
    }

    open_tool() {
        super.open_tool();
        const element_types = this.get_element_types();
        if (element_types.indexOf(this._mmm_composition) < 0)
            this._mmm_composition = element_types[0];
        this._initiate_creation();
        this.push_instruction_input(HELPER.mmm.creation);
    }

    //***********************************************************************************
    //**** Refresh
    //***********************************************************************************
    draw(camera) {
        this._creation_handler.visible = (this._focus_handler == this._creation_handler);
        return super.draw(camera);
    }

    //***********************************************************************************
    //**** Start creation of pipes
    //***********************************************************************************
    _initiate_creation() {
        if (this._creation_handler) {
            const index = this._handlers.indexOf(this._creation_handler);
            if (index >= 0) this._handlers.splice(index, 1);
        }
        var obj = this;
        var scene = obj._scene;
        this._creation_handler = (this._creation_mode<2)?cn_polygon_handler.create_open_polygon(this, this._creation_mode+1, false, false):cn_polygon_handler.create_rectangle(this);
    
        this._handlers.unshift(this._creation_handler);
        this._creation_handler.snap_elements = scene.spaces;

        //*** Event on creation start */
        this._creation_handler.on('start_creation', () => {
            obj._terminate_edition();
        });

        this._creation_handler.on('end_creation', () => {
            const new_pipes = [];
            this.push_transaction('Création de conduit');
            this.push_item_set(scene, 'pipes');
            const new_mmm = new cn_mmm_element(this._creation_handler.vertices.map(v => cn_clone(v)),this._mmm_composition,scene);
            scene.mmm_elements.push(new_mmm);
            this.call('creation', [new_mmm]);
            this._initiate_creation();
            this._initiate_edition([new_mmm]);
        });

    }

    //***********************************************************************************
    //**** Edition elements
    //***********************************************************************************
    /**
     * TODO : derivate in order to allow edition of other element in the process of creation
     * @param {cn_mouse_event} mouse_event
     * @returns {cn_element}
     */
    _find_other_element(mouse_event) {
        return this._scene.find_mmm_element(mouse_event.mouse_world, mouse_event.camera.snap_world_distance);
    }

    /**
     * TODO : derivate in order to provide an edition handler
     * @param {Array<cn_mmm_element>} elements
     * @returns {cn_edition_handler}
     */
    _build_edition_handler(elements) {
        return new cn_mmm_handler(elements, this._map, true);
    }

    /**
     * TODO : derivate in order to find siblings of an element
     * @param {cn_mmm_element} element
     * @returns {Array<cn_element>}
     */
    _get_siblings(element) {
        const ot = element.composition;
        return this._scene.mmm_elements.filter(s => s.composition == ot);
    }

}

